import React, { createContext, useState } from 'react';

// 1. Create the context
export const ThemeContext = createContext();

// 2. Create a provider component
export const ThemeProvider = ({ children }) => {
  const [verifiedGlobal, setVerifiedGlobal] = useState(false);
  const [registrationSuccessGlobal, setRegistrationSuccessGlobal] = useState(false);

  // Toggle theme function
  const updateVerifiedGlobal = (value) => {
    setVerifiedGlobal(value);
  };

  const updateSuccessRegistrationGlobal = (value) => {
    setRegistrationSuccessGlobal(value)
  }

  return (
    <ThemeContext.Provider value={{ verifiedGlobal, updateVerifiedGlobal, registrationSuccessGlobal, updateSuccessRegistrationGlobal }}>
      {children}
    </ThemeContext.Provider>
  );
};

